const TECHNIC_PARAMETERS = ['readonly', 'istest'];
const TILDA_PARAMETERS = ['action', 'orderId'];

const INFORMATION_PARAMETERS = ['description'];
const REQUIRED_PARAMETERS = ['phone', 'email'];
const SINGLES_PARAMETERS = ['comment', 'message', 'address'];

export const PAYMENT_PARAMETERS = ['amount'];

export const SENDER_PARAMETERS = [
  'name',
  ...REQUIRED_PARAMETERS,
  ...SINGLES_PARAMETERS,
];

export const FULL_PARAMETERS = [
  ...PAYMENT_PARAMETERS,
  ...INFORMATION_PARAMETERS,
  ...SENDER_PARAMETERS,
  ...TECHNIC_PARAMETERS,
  ...TILDA_PARAMETERS,
];
